// Vue dependences
import { createApp } from 'vue';
import isAllowedModuleAction from './plugins/is-allowed-module-action.js';

// i18n instance (shared with plain JS modules)
import i18n from './i18n.js';

// App
import App from './App.vue';

// Globally-registered reusable components (used across many pages/modals)
import ODNConfigButton from './components/odn-config-button.vue';
import ODNProceduresButton from './components/odn-procedures-button.vue';

// Store
import store from './store';

// Router
import router from './router';

// Ionic
import { IonicVue } from '@ionic/vue';

// PWA Elements
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// VCalendar
import { setupCalendar } from 'v-calendar';

// Dayjs
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';

import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import * as duration from 'dayjs/plugin/duration';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import * as objectSupport from 'dayjs/plugin/objectSupport';

dayjs.extend(localizedFormat);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(objectSupport);

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

const app = createApp(App)
  .use(IonicVue)
  .use(isAllowedModuleAction, store)
  .use(i18n)
  .use(setupCalendar)
  .use(store)
  .use(router);

app.component('ODNConfigButton', ODNConfigButton);
app.component('ODNProceduresButton', ODNProceduresButton);

defineCustomElements(window);

app.config.globalProperties.$dayjs = dayjs;

router.isReady().then(() => {
  app.mount('#app');
});
